import { Alert, Button, TextField } from "@mui/material";
import { useState, useEffect } from 'react';
import { useNavigate, useParams } from "react-router";

const EditProductPage = (props) => {

    const { id } = useParams();

    const navigate = useNavigate();
    //const id = '3406d58d-8826-4f69-af8e-a9a0df1900fe';
    
    const [name, setName] = useState("");
    const [barcode, setBarcode] = useState("");
    const [description, setDescription] = useState("");
    const [errorMessage, setErrorMessage] = useState(null);
    const [rec, setRec] = useState("");

    async function handleSubmit() {
        const myHeaders = new Headers();
        myHeaders.append('Content-Type', 'application/json');

        const requestOptions = {
            method: 'PUT',
            headers: myHeaders,
            body: JSON.stringify({
                'id': id,
                'barcode': barcode,
                'description': description
            })
        };
        const response = await fetch('/api/product', requestOptions);
        if(response.ok){
            setErrorMessage(null);
            navigate('/product', { state: {message: 'Produkt wurde erfolgreich geändert.'}})
        }else{
            const json = await response.json();
            setErrorMessage(json.message);
        }
    };

    useEffect(() => {
        const myHeaders = new Headers();
        myHeaders.append('Content-Type', 'application/json');

        const requestOptions = {
            method: 'GET',
            headers: myHeaders
        };
        fetch('/api/product/' + id, requestOptions)
        .then(r => r.json())
        .then(product => {
            setName(product?.name);
            setBarcode(product?.barcode);
            setDescription(product?.description);
        })
        .catch(error => {
            console.error(error);
        });

        fetch('/api/recommendation?productId=' + id, requestOptions)
        .then(r => r.json())
        .then(result => {
            setRec(JSON.stringify(result));
        })
        .catch(error => {
            console.error(error);
        });
    }, [id]);

    return(
        <div className="centered">
            <Button sx={{marginLeft:'15px !important'}} fullWidth className="custom-button-root" onClick={evt => window.location.assign('/product')}>zurück</Button> 
            <h2>Produkt bearbeiten</h2>
            <TextField 
                fullWidth
                label="Name"
                disabled
                value={name}
            />
            <TextField 
                fullWidth
                label="Barcode" 
                onChange={(event) => setBarcode(event.target.value)} 
                value={barcode}
            />
            <TextField
                fullWidth
                label="Beschreibung"
                multiline
                margin="normal"
                onChange={(event) => setDescription(event.target.value)} 
                value={description}
                placeholder="Beschreibung des Produkts (z.B. Menge)"
            />
            <Button sx={{marginLeft:'15px !important'}} fullWidth className={'custom-button-root'} onClick={() => handleSubmit()}>Speichern</Button>
            {errorMessage && <Alert severity="error">{errorMessage}</Alert>}
        </div>
    );
}

export default EditProductPage;